import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const IssuesRedirect = () => {
  useEffect(() => {
    window.location.href = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRl49F3SZVHR_iGS_fM0PWsPuGuZ_0-JB6XSAuDihDFDiYUeQyYCxOkGFNX5xGjl-ZHqpGbcIAdQ87M/pubhtml?widget=true&headers=false';
  }, []);

  return <Navigate to="/" />;
};

export default IssuesRedirect;
